export interface INavItem {
    isActive: boolean;
    icon: string;
    link: string;
    title: string;
    openInNewTab: boolean;
    subNavItems?: Array<any>;
    route?: string;
}

export interface IAppContainerPlaceholderNavItem {
    isActive: boolean;
    icon: string;
    title: string;
}

export interface IAppContainerState {
    initials: string,
    company: IAppContainerCompanyState | null,
    navigation: Array<IAppContainerPlaceholderNavItem>,
    isNavigationMinimized: boolean,
    helpText: string,
    pageName: string,
    footerLinks: Array<string>
}

export interface IAppContainerCompanyState {
    name: boolean,
    hasMultipleCompanies: boolean
}

export enum AppContainerStateChangeName {
    initials = 'initials',
    company = 'company',
    navigation = 'navigation',
    isNavigationMinimized = 'isNavigationMinimized',
    helpText = 'helpText',
    pageName = 'pageName',
    footerLinks = 'footerLinks'
}


// WEBPACK FOOTER //
// ./src/lib/components/app-container/shared/shared.interfaces.ts